import { render, staticRenderFns } from "./SourceLocation.vue?vue&type=template&id=315a298d&"
import script from "./SourceLocation.vue?vue&type=script&lang=js&"
export * from "./SourceLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports